// /src/components/ModalContainerWithI18n.js
// Wrapper for ModalContainer that provides i18n context

import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import ModalContainer from './ModalContainer';
import enTranslations from '../locales/en/translation.json';
import esTranslations from '../locales/es/translation.json';

// Initialize i18n instance for modals
const modalI18n = i18n.createInstance();

const ModalContainerWithI18n = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // Detect language from URL path
    const detectLanguage = () => {
      if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        // Check if path starts with /es/ or is exactly /es
        const isSpanish = path === '/es' || path === '/es/' || path.startsWith('/es/');
        console.log('[ModalI18n] Detecting language from path:', path, '=> Language:', isSpanish ? 'es' : 'en');
        return isSpanish ? 'es' : 'en';
      }
      return 'en';
    };

    const detectedLang = detectLanguage();

    modalI18n.init({
      resources: {
        en: { translation: enTranslations },
        es: { translation: esTranslations }
      },
      lng: detectedLang,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      },
      debug: false // Set to true if you need to debug i18n issues
    }).then(() => {
      console.log('[ModalI18n] Initialized with language:', modalI18n.language);
      setInitialized(true);
    });

    // Listen for language changes (e.g., when navigating between /en and /es)
    const handleLanguageChange = () => {
      const newLang = detectLanguage();
      if (modalI18n.language !== newLang) {
        console.log('[ModalI18n] Language changed to:', newLang);
        modalI18n.changeLanguage(newLang);
      }
    };

    // Listen for route changes
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', handleLanguageChange);
      return () => window.removeEventListener('popstate', handleLanguageChange);
    }
  }, []);

  if (!initialized) {
    return null;
  }

  return (
    <I18nextProvider i18n={modalI18n}>
      <ModalContainer />
    </I18nextProvider>
  );
};

export default ModalContainerWithI18n;
